import { Fragment, useEffect, useState, useLayoutEffect } from 'react';
import ApplicationsApi from '../../services/applications'
import ApartmentsApi from '../../services/apartments'
import UsersApi from '../../services/users'
// import { BeforeLoginStepProps } from '../Apartment/BeforeLoginStepper/BeforeLoginStepper'
// import NextStepButton from '../Apartment/BeforeLoginStepper/NextStepButton';
// import { History } from 'history';
// import { AddShowingsFormData } from '../../types/showings';
// import { BaseFormStepProps } from '../../types/instant-rent';
import { useParams } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles'
import {
    Box,
    Grid,
    Typography,
    CircularProgress,
    Checkbox,
    List,
    ListItem,
    ListItemIcon,
} from '@material-ui/core'
import Button from '@material-ui/core/Button';
import { paymentStyles } from '../../styles/paymentStyles'
import { apartmentStyles } from '../../styles/apartmentStyles'
import { Apartment, ApartmentStatus } from '../../types/apartments'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux';
import { navigate } from '../../actions/routes'
import './Payment.css';
//import ContractIcon from '../../images/paymentPage/contract.svg'
//import Login from '../Authentication/Login/index';
import Suggest from '../Apartment/Stepper/Steps/Suggest'
import DigivakuusFaqLink from '../../components/Digivakuus/DigivakuusFaqLink'

const useStylesCombined = makeStyles((theme) => ({
    ...paymentStyles(theme),
    ...apartmentStyles(theme),
}));

const Payment = () => {
    const MOBILE_BREAKPOINT = 900
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const classes = useStylesCombined();
    const [paymentProviders, setPaymentProviders] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [isProductsLoading, setIsProductsLoading] = useState(false)
    //const [isInMarketing, setIsInMarketing] = useState(false);
    const [isInCreated, setIsInCreated] = useState(false);
    const [couponCode, setCouponCode] = useState('');
    const [couponErrorMessage, setCouponErrorMessage] = useState<string | null>(null);
    const [couponSuccessMessage, setCouponSuccessMessage] = useState<string | null>(null);
    const [couponApplied, setCouponApplied] = useState(false);
    const [discountedVuokraoviPriceInCents, setDiscountedVuokraoviPriceInCents] = useState<number | null>(null);
    const [showPaymentMethods, setShowPaymentMethods] = useState(false);
    const { apartmentId, userId } = useParams<RouteParams>();
    // const [isChecked, setIsChecked] = useState(false);
    // const [showCheckboxError, setShowCheckboxError] = useState(false);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [totalPriceInCents, setTotalPriceInCents] = useState(0)
    const [products, setProducts] = useState([]);
    const [purchaseButtonDisabled, setPurchaseButtonDisabled] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT)
    const [showPremiumSelection, setShowPremiumSelection] = useState(false)
    const [hasCompletedPremiumSelection, setHasCompletedPremiumSelection] = useState(false)
    const [paymentFlowStarted, setPaymentFlowStarted] = useState(false)
    // const products = [
    //     { id: 1, name: "Leea", price: 0 },
    //     { id: 2, name: "Vuokraovi", price: 70 },
    //     { id: 3, name: "Oikotie", price: 70 },
    //     { id: 4, name: "FB/IG", price: 40 },
    // ];

    type RouteParams = {
        apartmentId: string;  // or number if you expect a number
        userId: string;       // same here
    };

    const premiumBundleTags = [
        'premiumProductBundleBasic',
        'premiumProductBundlePro',
        'premiumProductBundlePremium'
    ]
    const premiumBundleBadgeKeys: Record<string, string> = {
        premiumProductBundlePremium: 'paymentPage.premiumBundleBadges.premium'
    }
    const defaultPremiumCardStyles = {
        borderColor: '#E5E8EB',
        headerBackground: '#F2E7EE',
        headerColor: '#78204A',
        badgeBackground: '#94004A',
        badgeColor: '#FFFFFF'
    }
    const premiumBundleFeatureKeys: Record<string, string[]> = {
        premiumProductBundleBasic: [
            'paymentPage.premiumSuggestFaqDetailsTitle1',
            'paymentPage.premiumSuggestFaqDetailsTitle2',
            'paymentPage.premiumSuggestFaqDetailsTitle3'
        ],
        premiumProductBundlePro: [
            'paymentPage.premiumSuggestFaqDetailsTitle1',
            'paymentPage.premiumSuggestFaqDetailsTitle2',
            'paymentPage.premiumSuggestFaqDetailsTitle3',
            'paymentPage.premiumSuggestFaqDetailsTitle5',
            'paymentPage.premiumSuggestFaqDetailsTitle4'
        ],
        premiumProductBundlePremium: [
            'paymentPage.premiumSuggestFaqDetailsTitle1',
            'paymentPage.premiumSuggestFaqDetailsTitle2',
            'paymentPage.premiumSuggestFaqDetailsTitle3',
            'paymentPage.premiumSuggestFaqDetailsTitle5',
            'paymentPage.premiumSuggestFaqDetailsTitle4',
            'paymentPage.premiumSuggestFaqDetailsTitle6'
        ]
    }
    const premiumBundleDescriptionKeys: Record<string, string> = {
        premiumProductBundleBasic: 'paymentPage.premiumBundleDescription.basic',
        premiumProductBundlePro: 'paymentPage.premiumBundleDescription.plus',
        premiumProductBundlePremium: 'paymentPage.premiumBundleDescription.premium'
    }
    const premiumBundleSavingsKeys: Record<string, string> = {
        premiumProductBundleBasic: 'paymentPage.premiumBundleSavings.basic',
        premiumProductBundlePro: 'paymentPage.premiumBundleSavings.plus',
        premiumProductBundlePremium: 'paymentPage.premiumBundleSavings.premium'
    }
    const premiumBundleNameKeys: Record<string, string> = {
        premiumProductBundleBasic: 'paymentPage.premiumBundleNames.basic',
        premiumProductBundlePro: 'paymentPage.premiumBundleNames.plus',
        premiumProductBundlePremium: 'paymentPage.premiumBundleNames.premium'
    }

const isPremiumBundleProduct = (product: any) =>
        product?.tags?.some((tag: string) => premiumBundleTags.some(bundleTag => tag.startsWith(bundleTag)))
    const isPremiumPremiumProduct = (product: any) =>
        product?.tags?.includes('premiumProductBundlePremium') || product?.productId === '16'
    const getBundleFeatures = (product: any) => {
        const matchedTag = product?.tags?.find((tag: string) => premiumBundleFeatureKeys[tag])
        if (!matchedTag) return null
        return premiumBundleFeatureKeys[matchedTag].map(key => t(key))
    }
    const getBundleDescription = (product: any) => {
        const matchedTag = product?.tags?.find((tag: string) => premiumBundleDescriptionKeys[tag])
        return matchedTag ? t(premiumBundleDescriptionKeys[matchedTag]) : ''
    }
    const getBundleSavings = (product: any) => {
        const matchedTag = product?.tags?.find((tag: string) => premiumBundleSavingsKeys[tag])
        return matchedTag ? t(premiumBundleSavingsKeys[matchedTag]) : ''
    }
    const getBundleName = (product: any) => {
        const matchedTag = product?.tags?.find((tag: string) => premiumBundleNameKeys[tag])
        return matchedTag ? t(premiumBundleNameKeys[matchedTag]) : ''
    }
    const getProductDisplayName = (product: any) => {
        if (!product) return ''
        if (isPremiumBundleProduct(product)) {
            return getBundleName(product) || product.name
        }
        return product.name
    }

    const premiumProducts = products.filter(isPremiumBundleProduct)
    const selectedProductObjects = products.filter(product => selectedProducts.includes(product.productId))
    const premiumSelectionAvailable = premiumProducts.some(product => !product.productOwned)
    const shouldLimitPaymentProviders = typeof window !== 'undefined' && window.location.hostname === 'localhost'
    const shouldRenderPremiumStep = showPremiumSelection && premiumSelectionAvailable
    const visibleProducts = shouldRenderPremiumStep
        ? premiumProducts
        : selectedProductObjects
    const suggestContentKey = shouldRenderPremiumStep ? 'paymentPage.premiumSuggestBoxContent' : 'paymentPage.suggestBoxContent'
    const suggestContent = t(suggestContentKey)
    const paymentProvidersReady = Boolean(paymentProviders)
    const shouldDelaySelectedProducts = paymentFlowStarted && (!paymentProvidersReady || isLoading)
    const shouldShowSelectedProductsHeading = (!shouldRenderPremiumStep || paymentFlowStarted || showPaymentMethods) && !shouldDelaySelectedProducts
    const shouldRenderSelectedProductsSection = !shouldRenderPremiumStep && !shouldDelaySelectedProducts
    const productSelectionHeadingKey = shouldRenderPremiumStep
        ? 'paymentPage.choosePremiumBundleHeading'
        : shouldShowSelectedProductsHeading
            ? 'paymentPage.selectedProductsHeading'
            : 'paymentPage.chooseProducts'

    useEffect(() => {
        if (premiumSelectionAvailable) {
            if (!hasCompletedPremiumSelection && !showPremiumSelection) {
                setShowPremiumSelection(true)
            }
        } else if (showPremiumSelection) {
            setShowPremiumSelection(false)
        }
    }, [premiumSelectionAvailable, hasCompletedPremiumSelection, showPremiumSelection])

    const faqButtonClassName = 'faq-link-button'

    const renderFaqLink = () => (
        <DigivakuusFaqLink
            t={t}
            buttonClassName={faqButtonClassName}
            labelKeys={
                shouldRenderPremiumStep
                    ? ['paymentPage.premiumSuggestFaqTitle']
                    : undefined
            }
            contentKeys={
                shouldRenderPremiumStep
                    ? ['paymentPage.premiumSuggestFaqContent', 'apartments.rented.depositServiceInfo']
                    : undefined
            }
            titleKeys={
                shouldRenderPremiumStep
                    ? ['paymentPage.premiumSuggestFaqTitle', 'apartments.rented.depositServiceTitle']
                    : undefined
            }
            detailsSections={
                shouldRenderPremiumStep
                    ? [
                        {
                            key: 'premium-faq-detail-1',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle1',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer1'
                        },
                        {
                            key: 'premium-faq-detail-2',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle2',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer2'
                        },
                        {
                            key: 'premium-faq-detail-3',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle3',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer3'
                        },
                        {
                            key: 'premium-faq-detail-4',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle4',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer4'
                        },
                        {
                            key: 'premium-faq-detail-5',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle5',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer5'
                        },
                        {
                            key: 'premium-faq-detail-6',
                            titleKey: 'paymentPage.premiumSuggestFaqDetailsTitle6',
                            bodyKey: 'paymentPage.premiumSuggestFaqDetailsAnswer6'
                        }
                    ]
                    : undefined
            }
        />
    )

    const scrollToTop = () => {
        window.scrollTo(0, 0)
    }

    const suggestBoxPadding = '5px 0 15px 0'
    const faqFooter = shouldRenderPremiumStep
        ? (
            <div className='faq-link-wrapper'>
                {renderFaqLink()}
            </div>
        )
        : undefined

    const handlePremiumContinue = (newPrice?: number, selection?: string[]) => {
        setHasCompletedPremiumSelection(true)
        handleProceedToPayment(newPrice, selection)
    }

    const handleProceedToPayment = (newPrice?: number, selection?: string[]) => {
        setShowPremiumSelection(false)
        scrollToTop()
        setPaymentFlowStarted(true)
        rentalPaymentHandler(newPrice, selection)
    }

    const handleEditPremiumSelection = () => {
        setHasCompletedPremiumSelection(false)
        setShowPremiumSelection(true)
    }

    const handleSkipPremiumSelection = () => {
        setHasCompletedPremiumSelection(true)
        handleProceedToPayment(totalPriceInCents, selectedProducts)
    }

    const renderPremiumBundleCards = () => (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: '24px',
                width: '100%',
                marginTop: 0,
                marginBottom: '1.5rem'
            }}
        >
            {premiumProducts.map((product: any) => {
                const features = getBundleFeatures(product) || []
                const bundleDescription = getBundleDescription(product)
                const bundleSavings = getBundleSavings(product)
                const isDisabled = product.productOwned || product?.undeselectable
                const borderColor = defaultPremiumCardStyles.borderColor
                const headerBackground = defaultPremiumCardStyles.headerBackground
                const headerColor = defaultPremiumCardStyles.headerColor
                const badgeTag = product?.tags?.find((tag: string) => premiumBundleBadgeKeys[tag])
                const badgeLabel = badgeTag ? t(premiumBundleBadgeKeys[badgeTag]) : null
                const cardBoxShadow = '0px 4px 16px rgba(0, 0, 0, 0.08)'

                const handleCardClick = () => {
                    if (!isDisabled) {
                        handleProductSelect(product.productId)
                    }
                }

                return (
                    <div
                        key={product.productId}
                        onClick={handleCardClick}
                        style={{
                            flex: isMobile ? '1 1 100%' : '0 0 320px',
                            maxWidth: isMobile ? '100%' : '320px',
                            boxSizing: 'border-box',
                            border: `2px solid ${borderColor}`,
                            borderRadius: '16px',
                            overflow: 'hidden',
                            cursor: isDisabled ? 'default' : 'pointer',
                            opacity: isDisabled ? 0.6 : 1,
                            boxShadow: cardBoxShadow,
                            transition: 'all 0.2s ease-in-out',
                            background: '#FFFFFF',
                            position: 'relative'
                        }}
                    >
                        {badgeLabel && (
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '20px',
                                    right: '15px',
                                    background: defaultPremiumCardStyles.badgeBackground,
                                    color: defaultPremiumCardStyles.badgeColor,
                                    padding: '4px 12px',
                                    borderRadius: '999px',
                                    fontSize: '12px',
                                    fontWeight: 700,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.05em',
                                    boxShadow: '0 4px 10px rgba(148, 0, 74, 0.35)'
                                }}
                            >
                                {badgeLabel}
                            </div>
                        )}
                        <div
                            style={{
                                background: headerBackground,
                                color: headerColor,
                                padding: '20px 24px'
                            }}
                        >
                            <Typography
                                style={{
                                    fontSize: '20px',
                                    fontWeight: 600
                                }}
                            >
                                {getProductDisplayName(product)}
                            </Typography>
                            {bundleDescription && (
                                <Typography
                                    style={{
                                        marginTop: '6px',
                                        fontSize: '13px',
                                        opacity: 0.95
                                    }}
                                >
                                    {bundleDescription}
                                </Typography>
                            )}
                        </div>
                        <div
                            style={{
                                padding: '20px 24px',
                                minHeight: isMobile ? 'unset' : '320px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '16px'
                            }}
                        >
                            <Typography
                                style={{
                                    fontSize: '36px',
                                    fontWeight: 700,
                                    color: '#2F2F2F'
                                }}
                            >
                                {formatPriceDisplay(product.priceInEuros, t('paymentPage.freeOfCharge'))}
                            </Typography>
                            {bundleSavings && (
                                <Typography
                                    style={{
                                        fontSize: '13px',
                                        color: '#94004A',
                                        fontWeight: 600,
                                        marginTop: '-15px'
                                    }}
                                >
                                    {bundleSavings}
                                </Typography>
                            )}
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {features.map(feature => (
                                    <div
                                        key={`${product.productId}-${feature}`}
                                        style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}
                                    >
                                        <span
                                            style={{
                                                width: '8px',
                                                height: '8px',
                                                marginTop: '6px',
                                                borderRadius: '50%',
                                                background: '#94004A',
                                                flexShrink: 0
                                            }}
                                        />
                                        <Typography style={{ fontSize: '14px', color: '#4C5967' }}>
                                            {feature}
                                        </Typography>
                                    </div>
                                ))}
                            </div>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={(event) => {
                                    event.stopPropagation()
                                    handleProductSelect(product.productId, { proceedToPayment: true })
                                }}
                                disabled={isDisabled}
                                style={{
                                    marginTop: 'auto',
                                    width: '100%',
                                    height: '3rem',
                                    fontWeight: 600
                                }}
                            >
                                {t('paymentPage.choosePremiumBundle')}
                            </Button>
                        </div>
                    </div>
                )
            })}
        </div>
    )

    const handleProductSelect = (productId, options?: { proceedToPayment?: boolean }) => {
        const proceedToPayment = options?.proceedToPayment ?? false
        const product = products.find(p => p.productId === productId)

        if (product?.productOwned || product?.undeselectable) {
            return
        }

        let updatedSelection = []

        const alreadySelected = selectedProducts.includes(productId)

        if (alreadySelected && proceedToPayment) {
            return
        }
        const filterOutPremiumBundles = (selection: string[]) =>
            selection.filter(id => {
                const existingProduct = products.find(p => p.productId === id)
                return existingProduct && !isPremiumBundleProduct(existingProduct)
            })

        if (alreadySelected) {
            updatedSelection = selectedProducts.filter(id => id !== productId)
        } else {
            if (productId === '10') {
                updatedSelection = [
                    ...selectedProducts.filter(id => id !== '10'),
                    productId
                ]
            } else if (isPremiumBundleProduct(product)) {
                const selectionWithoutPremiums = filterOutPremiumBundles(selectedProducts)
                updatedSelection = [...selectionWithoutPremiums, productId]
            } else {
                updatedSelection = [...selectedProducts, productId]
            }
        }

        const newTotalPrice = updatedSelection.reduce((total, id) => {
            const selectedProduct = products.find(p => p.productId === id)
            if (!selectedProduct?.productOwned || product?.undeselectable) {
                return selectedProduct ? total + selectedProduct.priceInEuros * 100 : total
            }
            return total
        }, 0)

        setSelectedProducts(updatedSelection)
        setTotalPriceInCents(newTotalPrice)

        const allOwned = updatedSelection.every(id => {
            const selectedProduct = products.find(p => p.productId === id);
            return selectedProduct?.productOwned;
        })

        setPurchaseButtonDisabled(allOwned)

        if (showPaymentMethods) {
            rentalPaymentHandler(newTotalPrice, updatedSelection)
        }

        if (proceedToPayment && !alreadySelected) {
            handlePremiumContinue(newTotalPrice, updatedSelection)
        }
    }

    async function rentalPaymentHandler(newPrice?: number, nextSelectedProducts?: string[]) {
        try {
            setPurchaseButtonDisabled(true)
            setIsLoading(true)
            setPaymentProviders(null)

            const apartment: Apartment = await ApartmentsApi.getApartment(userId, apartmentId)
            if (!apartment) return

            if (apartment.status == ApartmentStatus.created) {
                setIsInCreated(true)
                setIsLoading(false)
                return
            }

            const priceToUse = newPrice ?? totalPriceInCents
            const productsForPayment = nextSelectedProducts ?? selectedProducts

        if (priceToUse === 0) {
            await addRightsAndPublish(apartment, productsForPayment)
        } else {
            setPaymentFlowStarted(true)
            const apartmentCode = apartment.code
            const apartmentInfo = {
                userId,
                    apartmentId,
                    apartmentCode,
                    publishCostInCents: priceToUse,
                    selectedProducts: productsForPayment,
                    ...(couponApplied ? { couponCode } : {})
                }

                const paymentResponse = await ApplicationsApi.initiatePaymentForPublish(apartmentInfo)
                const filteredResponse = {
                    ...paymentResponse,
                    providers: paymentResponse.providers?.filter(method =>
                        method.id !== 'amex' &&
                        method.id !== 'apple-pay' &&
                        method.id !== 'nordea-business' &&
                        method.id !== 'siirto'
                    ) || []
                }
                setShowPremiumSelection(false)
                scrollToTop()
                setShowPaymentMethods(true)
                setPaymentProviders(filteredResponse || null)
                setIsLoading(false)
            }
        } catch (error) {
            console.error(error)
        }
    }

    async function addRightsAndPublish(apartment: Apartment, rights: string[] = selectedProducts) {
        try {
            const response = await ApartmentsApi.addRights(apartment, rights);

            await ApartmentsApi.updateStatus(userId,
                apartmentId,
                { status: 'marketing' })
            //dispatch(navigate(`/apartments?status=ok`));
        } catch (error) {
            console.error('Error adding products:', error);
        }
    }

    const getProducts = async () => {
        setIsProductsLoading(true)
        try {
            const tags = ['platform', ...premiumBundleTags]
            const response = await ApartmentsApi.getProducts(tags)

            if (response && response.products) {
                const filteredProducts = response.products.filter(product =>
                    product.productId !== '8' &&
                    product.tags?.some(tag => ["platform", ...premiumBundleTags].includes(tag))
                );

                const premiumOrder = [
                    'premiumProductBundleBasic',
                    'premiumProductBundlePro',
                    'premiumProductBundlePremium'
                ]
                const getPremiumOrderIndex = (product: any) => {
                    const match = product.tags?.find((tag: string) => premiumOrder.includes(tag))
                    return match ? premiumOrder.indexOf(match) : -1
                }

                const sortedProducts = filteredProducts
                    .map(product => ({
                        ...product,
                        //productOwned: product.name === "Leea"
                        undeselectable: product.productId == "2"
                    }))
                    .sort((a, b) => {
                        const priorityOrder = ["2"]
                        const aIndex = priorityOrder.indexOf(a.productId)
                        const bIndex = priorityOrder.indexOf(b.productId)

                        if (aIndex === -1 && bIndex === -1) {
                            const aPremiumIndex = getPremiumOrderIndex(a)
                            const bPremiumIndex = getPremiumOrderIndex(b)

                            if (aPremiumIndex === -1 && bPremiumIndex === -1) {
                                return a.name.localeCompare(b.name)
                            }
                            if (aPremiumIndex === -1) return 1
                            if (bPremiumIndex === -1) return -1
                            return aPremiumIndex - bPremiumIndex
                        }
                        if (aIndex === -1) return 1
                        if (bIndex === -1) return -1
                        return aIndex - bIndex
                    })

                setProducts(sortedProducts)

                const leeaProductIds = sortedProducts
                    .filter(product => product.undeselectable)
                    .map(product => product.productId)

                setSelectedProducts(prevSelected => [...new Set([...prevSelected, ...leeaProductIds])])

                const vuokraoviProduct = sortedProducts.find(p => p.productId == "2")
                if (vuokraoviProduct && !vuokraoviProduct.productOwned) {
                    const priceInCents = Math.round(Number(vuokraoviProduct.priceInEuros) * 100)
                    setTotalPriceInCents(priceInCents)
                }

                await paymentPageHandler(sortedProducts)
            }
        } catch (error) {
            console.error('Error fetching products:', error)
        }
        setIsProductsLoading(false)
    }

    useEffect(() => {
        getProducts();
        //paymentPageHandler();
    }, []);

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    }, [location.pathname])

    async function paymentPageHandler(sortedProducts) {
        try {
            // You may want to start a loading state here
            // setLoading(true);
            //setIsLoading(true);

            // Fetch the apartment data
            const apartment: Apartment = await ApartmentsApi.getApartment(userId, apartmentId);
            if (!apartment) {
                // Handle error appropriately here
                return; // You can return here if you don't want to proceed further in case of an error
            }

            // if (apartment.status == ApartmentStatus.marketing) {
            //     setIsLoading(false);
            //     return;
            // }

            if (apartment.status == ApartmentStatus.created) {
                setIsInCreated(true);
                setIsLoading(false);
                return;
            }

            const rightsProductIds = (apartment.rights || []).filter(rightId =>
                sortedProducts.some(product =>
                    product.productId === rightId &&
                    (product.tags?.includes("platform") || premiumBundleTags.some(tag => product.tags?.includes(tag)))
                )
            );

            setPurchaseButtonDisabled(rightsProductIds.length > 0);

            setSelectedProducts(prevSelected => {
                const updatedSelection = [...new Set([...prevSelected, ...rightsProductIds])]
                return updatedSelection
            })

            setProducts(prevProducts => {
                const updatedProducts = prevProducts.map(product => {
                    const isproductOwned = rightsProductIds.includes(String(product.productId)) || product.productOwned
                    return {
                        ...product,
                        productOwned: isproductOwned
                    }
                })
                return updatedProducts
            })
            //setIsLoading(false);
        } catch (error) {
        }
    }

    async function handleCoupon(couponCode: string) {
        // Reset messages when attempting again
        setIsLoading(true);
        setCouponErrorMessage(null);
        setCouponSuccessMessage(null);
        setDiscountedVuokraoviPriceInCents(null);

        if (couponCode.length < 4) {
            setCouponErrorMessage(t('paymentPage.couponCodeTooShort'));
            setIsLoading(false);
            return;
        }

        try {
            const couponResponse = await ApplicationsApi.handlePaymentCoupon(couponCode, userId, 'platform');

            if (couponResponse && couponResponse.status === 'valid') {
                const discountInCents = couponResponse.discountInCents
                const discountPercentage = couponResponse.discountPercentage
                const aleCouponCodes = ['ale2025', 'ale2026']
                const isAleCoupon = aleCouponCodes.includes(couponCode.trim().toLowerCase())

                let newPrice = totalPriceInCents

                if (isAleCoupon) {
                    const vuokraoviProduct = products.find(p => p.productId === '2')
                    const vuokraoviPriceInCents = vuokraoviProduct ? Math.round(Number(vuokraoviProduct.priceInEuros || 0) * 100) : 0
                    const discountBase = Math.min(vuokraoviPriceInCents, totalPriceInCents)

                    let discountAmount = 0
                    if (discountInCents !== undefined && discountInCents !== null) {
                        discountAmount = Math.min(discountInCents, discountBase)
                    } else if (discountPercentage !== undefined && discountPercentage !== null) {
                        discountAmount = Math.round(discountBase * (discountPercentage / 100))
                    }

                    const discountedVuokraoviPrice = Math.max(0, discountBase - discountAmount)
                    const otherProductsTotal = Math.max(0, totalPriceInCents - discountBase)
                    newPrice = Math.max(0, otherProductsTotal + discountedVuokraoviPrice)

                    setDiscountedVuokraoviPriceInCents(discountedVuokraoviPrice)
                } else if (discountInCents !== undefined && discountInCents !== null) {
                    newPrice = Math.max(0, totalPriceInCents - discountInCents)
                } else if (discountPercentage !== undefined && discountPercentage !== null) {
                    const discount = discountPercentage / 100
                    newPrice = Math.max(0, totalPriceInCents * (1 - discount))
                }

                setCouponApplied(true);
                setTotalPriceInCents(newPrice);
                setCouponSuccessMessage(t('paymentPage.couponAppliedSuccessfully')); // New message for successful coupon application

                if (newPrice <= 0) {
                    setShowPaymentMethods(false);
                } else {
                    setShowPaymentMethods(true);
                    await rentalPaymentHandler(newPrice);  // Reinitialize the payment methods with the new price
                }


            } else if (couponResponse && couponResponse.status === 'failed') {
                if (couponResponse.message === 'Coupon not found') {
                    setCouponErrorMessage(t('paymentPage.couponNotFound'));
                } else if (couponResponse.message === 'Wrong use case') {
                    setCouponErrorMessage(t('paymentPage.couponWrongUseCase'));
                } else if (couponResponse.message === 'Coupon has expired') {
                    setCouponErrorMessage(t('paymentPage.couponExpired'));
                } else if (couponResponse.message === 'Coupon already used') {
                    setCouponErrorMessage(t('paymentPage.couponAlreadyUsed'));
                } else {
                    // Handle other unexpected messages
                    setCouponErrorMessage(t('paymentPage.couponNotFound'));
                }
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }

    const formatPriceDisplay = (priceInEuros: number, freeText: string) => {
        if (priceInEuros === 0) return freeText
        if (priceInEuros % 1 === 0) return `${priceInEuros},00 €`
        return priceInEuros.toFixed(2).replace('.', ',') + ' €'
    }

    const renderProductPrice = (product: any) => {
        const isVuokraovi = product.productId === '2'
        const hasVuokraoviDiscount = couponApplied && discountedVuokraoviPriceInCents !== null && isVuokraovi
        const discountedPriceEuros = hasVuokraoviDiscount && discountedVuokraoviPriceInCents !== null
            ? discountedVuokraoviPriceInCents / 100
            : null

        if (product.productOwned) {
            return (
                <Box
                    style={{
                        width: "81px",
                        height: "32px",
                        background: "#94004A",
                        borderRadius: "8px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Typography
                        style={{
                            fontSize: "16px",
                            fontWeight: "700",
                            color: "#FFFFFF",
                            textAlign: "center",
                        }}
                    >
                        {t('paymentPage.productOwned')}
                    </Typography>
                </Box>
            )
        }

        if (hasVuokraoviDiscount) {
            return (
                <Box style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <Box
                        style={{
                            minWidth: "81px",
                            height: "32px",
                            background: "#CBD4DA",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: "14px",
                                fontWeight: "600",
                                color: "#374151",
                                textDecoration: 'line-through',
                            }}
                        >
                            {formatPriceDisplay(product.priceInEuros, t('paymentPage.freeOfCharge'))}
                        </Typography>
                    </Box>
                    <Box
                        style={{
                            minWidth: "81px",
                            height: "32px",
                            background: "#94004A",
                            borderRadius: "8px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Typography
                            style={{
                                fontSize: "16px",
                                fontWeight: "700",
                                color: "#FFFFFF",
                                textAlign: "center",
                            }}
                        >
                            {formatPriceDisplay(discountedPriceEuros ?? 0, t('paymentPage.freeOfCharge'))}
                        </Typography>
                    </Box>
                </Box>
            )
        }

        return (
            <Box
                style={{
                    width: "81px",
                    height: "32px",
                    background: "#94004A",
                    borderRadius: "8px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Typography
                    style={{
                        fontSize: "16px",
                        fontWeight: "700",
                        color: "#FFFFFF",
                        textAlign: "center",
                    }}
                >
                    {formatPriceDisplay(product.priceInEuros, t('paymentPage.freeOfCharge'))}
                </Typography>
            </Box>
        )
    }

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT)
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])
    async function plainPublishFunction() {
        // Reset messages when attempting again        
        // if (!isChecked) {
        //     setShowCheckboxError(true); // Show error if button is clicked without checking
        // } else {
        setIsLoading(true);
        //setShowCheckboxError(false);
        try {
            const apartment: Apartment = await ApartmentsApi.getApartment(userId, apartmentId)

            await addRightsAndPublish(apartment)
            // dispatch(navigate(`/users/${userId}/apartments/${apartmentId}/overview?status=ok`));

            const coupons: { couponCode: string } = {
                couponCode
            };
            try {
                const response = await UsersApi.updateUserUsedCoupons(userId, coupons)
                // dispatch(navigate(`/users/${userId}/apartments/${apartmentId}/overview?status=ok`));
            } catch (error) {
                console.error(error);
            }

        } catch (error) {
            console.error(error)
        }
        setIsLoading(false);
        //}
    }

    return (
        <Fragment>
            <div className="container payment-page">
                <div className="single-column">
                    <Grid container direction='row' justify='space-evenly'>
                        <Grid container>
                            <Grid item xs={12}>
                                {/* <Typography
                                variant='h4'
                                className={`${classes.centeredText} ${classes.heading
                                    } ${isMobile ? classes.my6 : classes.my8}`}
                            > */}

                                {(!isInCreated) ? (
                                    !isProductsLoading) ? (
                                    <>
                                        {!shouldDelaySelectedProducts && (
                                            <>
                                                <h2 className="additionalMarginTopMd"> {t(productSelectionHeadingKey)}</h2>
                                                {shouldRenderPremiumStep && !showPaymentMethods && !isLoading && (
                                                    <Grid item xs={12}>
                                                        <Grid container justifyContent="center">
                                                            <Grid item xs={12} sm={10} md={8}>
                                                                <Suggest
                                                                    content={suggestContent}
                                                                    containerMaxWidth='100%'
                                                                    contentMaxWidth='100%'
                                                                    padding={suggestBoxPadding}
                                                                    footerContent={faqFooter}
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                )}
                                                {shouldRenderPremiumStep ? (
                                                    <>
                                                        {renderPremiumBundleCards()}
                                                        <div
                                                            style={{
                                                                marginTop: '1.5rem',
                                                                display: 'flex',
                                                                justifyContent: 'center'
                                                            }}
                                                        >
                                                            <Button
                                                                onClick={handleSkipPremiumSelection}
                                                                variant="text"
                                                                color="primary"
                                                                style={{
                                                                    fontWeight: 700,
                                                                    textTransform: 'none',
                                                                    fontSize: '22px',
                                                                    display: 'inline-flex',
                                                                    alignItems: 'center',
                                                                    padding: 0
                                                                }}
                                                            >
                                                                <span
                                                                    style={{
                                                                        borderBottom: '2px solid currentColor',
                                                                        display: 'inline-flex',
                                                                        alignItems: 'center',
                                                                        paddingBottom: '2px'
                                                                    }}
                                                                >
                                                                    <span>{t('paymentPage.skipPremiumBundleLink')}</span>
                                                                    <span
                                                                        aria-hidden="true"
                                                                        style={{ marginLeft: '10px' }}
                                                                    >
                                                                        &rarr;
                                                                    </span>
                                                                </span>
                                                            </Button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    shouldRenderSelectedProductsSection && (
                                                    <div className="payment-section">
                                                        <List style={{ width: '100%' }}>
                                                            {visibleProducts.map((product) => {
                                                                const productIsSelected = selectedProducts.includes(product.productId)
                                                                return (
                                                                    <ListItem
                                                                        key={product.productId}
                                                                        divider
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "row",
                                                                            justifyContent: "space-between",
                                                                            alignItems: "center",
                                                                            padding: "12px 12px 10px 12px",
                                                                            width: "100%",
                                                                            background: "#F7F8F9",
                                                                            borderRadius: "12px",
                                                                            margin: "8px 0px",
                                                                            boxSizing: "border-box",
                                                                            backgroundColor: productIsSelected ? "#FCF3F5" : "#F7F8F9",
                                                                        }}
                                                                    >
                                                                        <Box
                                                                            style={{
                                                                                display: "flex",
                                                                                flexDirection: "row",
                                                                                alignItems: "center",
                                                                                gap: "12px",
                                                                                flex: 1,
                                                                                minWidth: 0
                                                                            }}
                                                                        >
                                                                            <ListItemIcon style={{ minWidth: "30px" }}>
                                                                                <Checkbox
                                                                                    className="checkbox"
                                                                                    checked={productIsSelected}
                                                                                    disabled={product.productOwned}
                                                                                    onChange={() => handleProductSelect(product.productId)}
                                                                                    style={{
                                                                                        transform: "scale(1.2)",
                                                                                        color: productIsSelected ? "#94004A" : "#CBD4DA",
                                                                                    }}
                                                                                    color="primary"
                                                                                />
                                                                            </ListItemIcon>
                                                                            <Typography
                                                                                style={{
                                                                                    fontSize: "14px",
                                                                                    fontWeight: 500,
                                                                                    color: "#2F2F2F",
                                                                                    overflow: 'hidden',
                                                                                    textOverflow: 'ellipsis',
                                                                                    whiteSpace: 'nowrap',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center'
                                                                                }}
                                                                            >
                                                                                {getProductDisplayName(product)}
                                                                            </Typography>
                                                                    </Box>
                                                                        <Box
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "flex-end",
                                                                                gap: "8px",
                                                                                minWidth: "81px",
                                                                            }}
                                                                        >
                                                                            {renderProductPrice(product)}
                                                                        </Box>
                                                                    </ListItem>
                                                                )
                                                            })}
                                                        </List>
                                                    </div>
                                                    )
                                                )}
                                            </>
                                        )}
                                        {!purchaseButtonDisabled && !shouldRenderPremiumStep && (
                                            <div style={{
                                                marginTop: '0.5rem',
                                                marginBottom: isMobile ? '2.5rem' : '0.2rem',
                                                marginLeft: '20px',
                                                marginRight: '20px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '0.5rem'
                                            }} className={`${classes.centeredText}`} >
                                                {!showPaymentMethods && (
                                                    <Button
                                                        onClick={() => handleProceedToPayment()}
                                                        variant="contained"
                                                        color="primary"
                                                        className={`${classes.centeredText}`}
                                                        style={{ width: '100%', height: '3.5rem' }}
                                                    >
                                                        {t('paymentPage.confirmPurchase')}
                                                    </Button>
                                                )}
                                            </div>
                                        )}
                                        {!shouldRenderPremiumStep && !showPaymentMethods && !isLoading && !isMobile && (
                                            <Grid item xs={12}>
                                                <Grid container justifyContent="center">
                                                    <Grid item xs={12} sm={6}>
                                                        <Suggest
                                                            content={suggestContent}
                                                            containerMaxWidth='100%'
                                                            contentMaxWidth='100%'
                                                            padding={suggestBoxPadding}
                                                            footerContent={faqFooter}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </>
                                ) : (
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        width: '100%'
                                    }}>
                                        <CircularProgress
                                            size={72}
                                            style={{ color: '#94004A', margin: '25px' }}
                                        />
                                    </div>
                                ) : null}
                            </Grid>
                            {!isLoading ? (
                                !isInCreated ? (
                                    showPaymentMethods ? (
                                        <div>
                                            <div >
                                                {/* <Typography
                                            variant='h4'
                                            className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                        >
                                            {t('paymentPage.choosePaymentMethod')}
                                        </Typography> */}
                                                <h2 className="additionalMarginTopMd"> {t('paymentPage.choosePaymentMethod')}</h2>
                                                {/* <h2 className="additionalMarginTopMd"> {t('paymentPage.paymentTerms')}</h2> */}
                                            </div>
                                            {paymentProviders !== undefined && paymentProviders ? (
                                                <>
                                                    {/* <Typography
                                                        variant='h5'
                                                        className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                                        style={{ marginBottom: '10px' }}
                                                    >
                                                        {t('paymentPage.choosePaymentMethod')}
                                                    </Typography> */}
                                                    <div className={`payment-section`}>
                                                        <div className={classes.paymentOptionPage}>
                                                            {(
                                                                shouldLimitPaymentProviders
                                                                    ? paymentProviders.providers
                                                                        .filter((provider: any) => {
                                                                            const identifier = `${provider?.name ?? ''} ${provider?.value ?? ''}`.toLowerCase()
                                                                            return !identifier.includes('google pay')
                                                                        })
                                                                        .slice(0, 12)
                                                                    : paymentProviders.providers
                                                            ).map((provider: any) => (
                                                                <form
                                                                    method='POST'
                                                                    action={provider.url}
                                                                    key={provider.id}
                                                                    className={classes.paymentCard}
                                                                    onSubmit={(event) => {
                                                                        event.preventDefault()
                                                                        event.currentTarget.submit()
                                                                    }}
                                                                >
                                                                    {provider.parameters.map(
                                                                        (param: {
                                                                            name: string | undefined
                                                                            value:
                                                                            | string
                                                                            | number
                                                                            | readonly string[]
                                                                            | undefined
                                                                        }) => (
                                                                            <input
                                                                                key={param.name}
                                                                                type='hidden'
                                                                                name={param.name}
                                                                                value={param.value}
                                                                            />
                                                                        )
                                                                    )}
                                                                    <button className="paymentProvider">
                                                                        <img
                                                                            style={{
                                                                                objectFit: 'contain',
                                                                                width: '95%',
                                                                            }}
                                                                            src={provider.svg}
                                                                            alt={provider.value}
                                                                        />
                                                                    </button>
                                                                </form>
                                                            ))}
                                                        </div>
                                                    </div>
                                                <div className="couponTermsSection">
                                                    <Typography
                                                        variant='body2'
                                                        className="couponInfoText"
                                                    >
                                                        {t('paymentPage.couponSuggestContent')}
                                                    </Typography>
                                                    {!couponApplied && (
                                                        <form
                                                            className={`couponForm`}
                                                            onSubmit={(event) => {
                                                                event.preventDefault();
                                                                handleCoupon(couponCode);
                                                            }}
                                                        >
                                                            <input
                                                                type="text"
                                                                placeholder={t('paymentPage.insertCouponCode')}
                                                                onChange={(e) => {
                                                                    setCouponCode(e.target.value);
                                                                }}
                                                                className={`couponInput`}
                                                            />
                                                            <Button type="submit" variant="contained" color="primary" className={`couponButton`}
                                                                style={{
                                                                    height: '3.05rem',
                                                                    paddingLeft: '25px',
                                                                    paddingRight: '25px',
                                                                }}>
                                                                {t('paymentPage.applyCoupon')}
                                                            </Button>
                                                        </form>
                                                    )}
                                                    {couponErrorMessage && (
                                                        <Typography
                                                            variant='body1'
                                                            className={`couponForm errorText couponMessage`}
                                                        >
                                                            {couponErrorMessage}
                                                        </Typography>
                                                    )}
                                                    {couponSuccessMessage && (
                                                        <Typography
                                                            variant='body1'
                                                            className={`couponForm successText couponMessage`}
                                                        >
                                                            {couponSuccessMessage}
                                                        </Typography>
                                                    )}
                                                    <Typography
                                                        variant='body2'
                                                        className="paymentTermsDisclaimer"
                                                    >
                                                        {t('paymentPage.paymentTermsDisclaimerTextPart')}{' '}
                                                        <a
                                                            style={{ color: '#94004A', textDecoration: 'none', fontWeight: 'bold' }}
                                                            href='https://www.leea.fi/kayttoehdot'
                                                            target='_blank'
                                                            rel='noreferrer'
                                                        >
                                                            {t('paymentPage.paymentTermsDisclaimerLinkPart')}
                                                        </a>
                                                    </Typography>
                                                </div>
                                                </>
                                            ) : (
                                                <Grid item xs={12}>
                                                    {/* <Typography
                                        variant='h5'
                                        className={`${classes.centeredText} ${classes.heading
                                            } ${isMobile ? classes.my6 : classes.my8}`}
                                    >
                                        {t('general.notAvailable')}
                                    </Typography> */}
                                                    <Typography
                                                        variant='h5'
                                                        className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                                    >
                                                        {t('paymentPage.paymentProvidersNotFound')}
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </div>
                                    ) : (
                                        couponApplied && totalPriceInCents === 0 && (
                                            <>
                                                <div style={{ width: '100%' }} className={`${classes.centeredText} ${classes.my6}`}>
                                                    {couponSuccessMessage && (
                                                        <Typography
                                                            variant='body1'
                                                            className={`${classes.centeredText} ${classes.my6}`}
                                                            style={{ color: 'green', width: '100%', marginTop: '5px' }}
                                                        >
                                                            {couponSuccessMessage}
                                                        </Typography>
                                                    )}

                                                    <Button
                                                        onClick={() => plainPublishFunction()}
                                                        variant="contained"
                                                        color="primary"
                                                        className={`${classes.centeredText}`}
                                                    >
                                                        {t('paymentPage.publish')}
                                                    </Button>
                                                </div>
                                            </>
                                        )
                                    )
                                ) : (
                                    <Typography
                                        variant='h4'
                                        className={`${classes.centeredText} ${classes.heading} ${classes.my8}`}
                                        style={{ marginBottom: '10px', width: '100%' }}
                                    >
                                        {t('paymentPage.isUnfinished')}
                                    </Typography>
                                )) : (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    width: '100%'
                                }}>
                                    <CircularProgress
                                        size={72}
                                        style={{ color: '#94004A', margin: '25px' }}
                                    />
                                </div>
                            )}
                        </Grid>
                        {/* <Grid container className={classes.buttonContainer}>
                        <NextStepButton
                            type='button'
                            beforeLogin={beforeLogin}
                            setIsEmpty={setIsEmpty}
                            toValidate={{
                                buildingType: buildingInfo.buildingType
                            }}
                        />
                    </Grid> */}
                    </Grid>
                </div>
            </div>
        </Fragment >
    );
};

//export default withTranslation(Payment as any)
export default Payment
